import styled from 'styled-components'

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  margin-bottom: 1.5rem;
  padding-bottom: 0.875rem;
  border-bottom: 1px solid ${props => props.theme.colors.border.light};
`

const IconWrapper = styled.div`
  width: ${props => props.theme.controlHeight};
  height: ${props => props.theme.controlHeight};
  background: ${props => props.theme.colors.text.primary};
  border-radius: ${props => props.theme.radius.small};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.background.primary};
  font-size: 0.875rem;
  transition: ${props => props.theme.transitions.default};
`

const Title = styled.h2`
  font-size: ${props => props.theme.typography.fontSize.cardTitle};
  font-weight: 500;
  color: ${props => props.theme.colors.text.primary};
  margin: 0;
  letter-spacing: -0.01em;
  font-family: ${props => props.theme.typography.fontFamily};
`

export default function CardHeader ({ icon: Icon, title }) {
  return (
    <HeaderContainer>
      <IconWrapper>
        <Icon />
      </IconWrapper>
      <Title>{title}</Title>
    </HeaderContainer>
  )
}
